import { render, staticRenderFns } from "./Page3.vue?vue&type=template&id=fed753d6&scoped=true"
import script from "./Page3.vue?vue&type=script&lang=js"
export * from "./Page3.vue?vue&type=script&lang=js"
import style0 from "./Page3.vue?vue&type=style&index=0&id=fed753d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed753d6",
  null
  
)

export default component.exports